<template>
    <div>
        <vx-navbar color="light" class="vx-mb-6 sm:vx-mb-12">
            <template v-slot:left>
                <vx-navbar-action href="/" class="hide-action-icon" :marker="false">
                    <navbar-logo></navbar-logo>
                    <span class="vx-hidden vx-text-base vx-text-slate-800 sm:vx-block">Kiosk Mode</span>
                </vx-navbar-action>
            </template>

            <vx-navbar-action
                color="light"
                :icon="faUsers"
                href="/kiosk/teams"
                class="hide-action-icon"
                :active="isActive(match(['/kiosk/teams{/*path}']))"
            >
                <span>Teams</span>
            </vx-navbar-action>
            <vx-navbar-action
                color="light"
                :icon="faUser"
                href="/kiosk/users"
                class="hide-action-icon"
                :active="isActive(match(['/kiosk/users{/*path}']))"
            >
                <span>Users</span>
            </vx-navbar-action>
        </vx-navbar>
    </div>
    <component :is="props.formContainer ? FormContainer : PageContainer">
        <slot></slot>
    </component>
</template>

<script setup>
import { faUser, faUsers } from '@fortawesome/pro-solid-svg-icons';
import { VxNavbar, VxNavbarAction } from '@voxie/frontend-components';
import { match } from 'path-to-regexp';
import PageContainer from '~/components/general/PageContainer.vue';
import NavbarLogo from '~/components/navbar/NavbarLogo.vue';
import FormContainer from '~/components/general/FormContainer.vue';

const props = defineProps({
    formContainer: {
        type: Boolean,
        default: false,
    },
});

const isActive = (pathMatcher) => {
    return Boolean(pathMatcher(window.location.pathname));
};
</script>
